import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DataExtractionService } from '@/infra/services/data-extraction';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';

interface DeleteDataExtractionParams {
	data_extraction_id: string;
	organization_id: string;
	company_id: string;
}

const Service = DataExtractionService.getInstance();

export const useDeleteDataExtraction = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DeleteDataExtractionParams) => Service.destroy(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_DATA_EXTRACTION_LIST]);
			message.success(I18n.get('Extraction deleted successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error deleting extraction'));
		}
	});
};
